import styled from 'styled-components';
import { color } from '../../assets/styles/colors';

export const TextStyled = styled.div`
	font-size: ${(props) => props.size === 'default' && '16px'};
	font-weight: ${(props) => props.weight === 'bold' && 600};
	font-size: ${(props) => props.size === 'small' && '12px'};
	@media screen and (max-width: 1400px) {
		font-size: ${(props) => props.size === 'small' && '10px'};
		font-size: ${(props) => props.size === 'medium' && '12px'};
		font-size: ${(props) => props.size === 'big' && '18px'};
	}
	font-size: ${(props) => props.size === 'medium' && '16px'};
	font-size: ${(props) => props.size === 'big' && '24px'};
	font-size: ${(props) => props.size === 'large' && '36px'};
	text-align: ${(props) => props.center && 'center'};
	color: ${(props) => props.color === 'default' && color.gray};
	color: ${(props) => props.color === 'gray' && color.gray};
	color: ${(props) => props.color === 'grayMedium' && color.grayMedium};
	color: ${(props) => props.color === 'white' && color.white};
	color: ${(props) => props.color === 'red' && color.red};
	color: ${(props) => props.color === 'green' && color.green};
	color: ${(props) => props.color === 'black' && color.black};
	color: ${(props) => props.color === 'blue' && color.blue};
	color: ${(props) => props.color === 'yellow' && color.yellow};
	text-align: ${(props) => props.center && 'center'};
`;
